import React from "react";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import Banner from "apps/messenger/components/MainWindow/Banners/Banner";
import FullInboxBanner from "apps/messenger/components/MainWindow/Banners/FullInboxBanner";
import ScamBanner from "apps/messenger/components/MainWindow/Banners/ScamBanner";
import FeedbackBanner from "apps/messenger/components/MainWindow/Banners/FeedbackBanner";
import InactiveBanner from "apps/messenger/components/MainWindow/Banners/InactiveBanner";

const BANNER_SLIDE_SPEED = 3000;

// Banners show up within MainWindow.
// They do not necessarily block send nor prevent
// showing messages—that logic is independent.
const Banners = ({
	name,
	error,
	showFullInboxWarning,
	showScammerWarning,
	showFeedbackAgentWarning,
	showInactiveWarning,
}) => (
	<ReactCSSTransitionGroup
		component={React.Fragment}
		transitionName="messenger-banner-transition"
		transitionEnterTimeout={BANNER_SLIDE_SPEED}
		transitionLeaveTimeout={BANNER_SLIDE_SPEED}
	>
		{error && (
			<Banner danger>
				{error}
			</Banner>
		)}
		{showFullInboxWarning && (
			<Banner>
				<FullInboxBanner name={name} />
			</Banner>
		)}
		{showScammerWarning && (
			<Banner>
				<ScamBanner />
			</Banner>
		)}
		{showFeedbackAgentWarning && (
			<Banner>
				<FeedbackBanner />
			</Banner>
		)}
		{showInactiveWarning && (
			<Banner>
				<InactiveBanner name={name} />
			</Banner>
		)}
	</ReactCSSTransitionGroup>
);

Banners.propTypes = {
	name: PropTypes.string.isRequired,
	error: PropTypes.string,
	showFullInboxWarning: PropTypes.bool,
	showScammerWarning: PropTypes.bool,
	showFeedbackAgentWarning: PropTypes.bool,
	showInactiveWarning: PropTypes.bool,
};

Banners.defaultProps = {
	error: null,
	showFullInboxWarning: false,
	showScammerWarning: false,
	showFeedbackAgentWarning: false,
	showInactiveWarning: false,
};

export default Banners;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Banners/index.jsx